import Vue from "vue";
import VueRouter from "vue-router";
import { links } from "./config";

Vue.use(VueRouter);

const routes = [];

// fill routes
links.forEach((link) => {
  routes.push({
    path: link.path,
    name: link.title ? link.title.toLowerCase() : link.name,
    // route level code-splitting
    // this generates a separate chunk (component.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: link.component,
  });
});

// push 404 redirecting
routes.push({ path: "*", redirect: "/404" });

const routerInstance = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

routerInstance.afterEach(() => {
  window.scrollTo(0, 0);
});

export default routerInstance;
